import { useEffect, useRef, useState } from 'react';
import { NIcon } from '@nemo/react';
import { useMixpanelContext } from '../../providers/MixpanelContext';
import { useUserContext } from '../../providers/UserContext';
import { ReactComponent as CaretDown } from '../../assets/image/caret-down.svg';
import { ReactComponent as LinkIcon } from '../../assets/image/arrow-square-out-grey.svg';

interface HeaderDropdownBtnProps {
  btnTitle: string;
}

function HeaderDropdownBtn({ btnTitle }: HeaderDropdownBtnProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { mixpanelTrackEvent } = useMixpanelContext();
  const { tutorByIesId } = useUserContext();

  const [isOptionsOpen, setIsOptionsOpen] = useState<boolean>(false);

  const togglePillOptions = () => {
    setIsOptionsOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    setIsOptionsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        closeDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const openLinkInNewTab = () => {
    window.open(
      'https://dprcdc77c28qr.cloudfront.net/assets/TutorGuide/Mondly%20-%20Language%20Tutoring%20-%20Tutor%20Manual.pdf',
      '_blank',
    );
    mixpanelTrackEvent('TutorPortalTutorManualClick', {
      tutor: tutorByIesId,
    });
    closeDropdown();
  };

  return (
    <div className="header-dropdown-btn-container" ref={dropdownRef}>
      <button
        type="button"
        className={`header-dropdown-btn ${isOptionsOpen ? 'open' : ''}`}
        onClick={() => togglePillOptions()}
      >
        <div className="title">{btnTitle}</div>
        <div className={`caret ${isOptionsOpen ? 'open' : ''}`}>
          <CaretDown />
        </div>
      </button>
      {isOptionsOpen && (
        <div className="dropdown-menu">
          <button
            type="button"
            className="dropdown-item flex space-between"
            onClick={() => openLinkInNewTab()}
          >
            <div className="flex gap-12">
              <NIcon size="md" name="book-open" />
              Tutor manual
            </div>
            <span style={{ display: 'flex' }}>
              <LinkIcon />
            </span>
          </button>
        </div>
      )}
    </div>
  );
}

export default HeaderDropdownBtn;
